import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'react-addons-update';
import ReactTable from 'react-table';
import scroll from 'helpers/scroll';
import cm from 'helpers/commons';
import { Popup } from 'semantic-ui-react';
import { Commons } from 'components';

const propTypes = {};

const defaultProps = {};
class StaffList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: [],
      headers: [
        { header: '', width: 56, isChecked: true, className: 'allCheckbox' },
        { header: 'ID', width: 120, clickAction: true },
        { header: '이름', width: 116 },
        { header: '식대그룹', width: 128 },
        { header: '사원번호', width: 128 },
        { header: '권한', width: 88 }
      ],
      heightIdx: 0,
      containerHeight: 620,
      isInfiniteLoading: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { staffCheckedData, staffList } = this.props;
    const { elements, isInfiniteLoading } = this.state;
    const { staffCheckedData: nCheckedData, staffList: nStaffList } = nextProps;
    const { elements: nElements, isInfiniteLoading: nIsInfiniteLoading } = nextState;

    const changeStaffList = staffList !== nStaffList;
    const changeCheckedData = staffCheckedData !== nCheckedData;
    // const changeElements = elements !== nElements;
    const changeLoading = isInfiniteLoading !== nIsInfiniteLoading;
    return changeStaffList || changeCheckedData || changeLoading;
  }

  componentWillMount() {}

  componentDidMount() {
    let windowH = $(window).height();
    let searchFormH = $('.search-form').outerHeight();
    let topMenuH = $('.top-menu').outerHeight();
    let bottomFormH = $('.bottom-form').outerHeight();

    let listH = windowH - (searchFormH + topMenuH + bottomFormH + 150 + 48);

    this.setState({
      containerHeight: update(this.state.param, { $set: listH })
    });
    // this.scrollEvent(this.props.staffList)
  }

  componentDidUpdate() {
    const { isChecked, staffCheckedData, params } = this.props;
    const { elements } = this.state;
    if (isChecked || staffCheckedData.length > 0) {
      //검색 된 인원만 전체 선택
      const isAllChecked = false;
      staffCheckedData.forEach((data) => {
        $('#' + data.id).prop('checked', true);
      });
    } else {
      $('.staff-checkbox').prop('checked', false);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { staffCheckedData: nCheckData, staffList: nStaffList } = nextProps;
    const { staffCheckedData, staffList } = this.props;
    const staffListChange = JSON.stringify(staffList) !== JSON.stringify(nStaffList);

    if (staffListChange) {
      this.scrollEvent(nextProps.staffList);
    }
  }

  scrollEvent = (staffList) => {
    if (staffList && staffList.data.user) {
      const { user } = staffList.data;
      let count = user.length > 100 ? 100 : user.length;
      this.setState({
        elements: this.buildElements(0, count, user, false),
        isInfiniteLoading: false
      });
    } else {
      this.setState({ elements: [] });
    }
  };

  handleInfiniteLoad = async () => {
    const { staffList, staffSel } = this.props;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = staffList ? staffList.data.paging : null;

    let that = this;
    let elemLength = elements.length;
    let itemLength = item ? item.totalcount : 0;
    const infiniteParm = scroll.event(item, elements, containerHeight, heightIdx, elemLength);
    const params = {};
    if (elemLength < itemLength) {
      if (this.props.params) {
        params['keyword'] = this.props.params.keyword;
        params['orgCode'] = this.props.params.orgCode;
        params['auth'] = this.props.params.auth;
        params['groupid'] = this.props.params.groupid;
      }

      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });

      const { staffList } = this.props;
      let data = this.buildElements(elemLength, elemLength + 100, staffList.data.user, false);

      setTimeout(function() {
        that.setState({
          elements: that.state.elements.concat(data),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      // this.setState({
      //   isInfiniteLoading : false
      // })
    }
  };

  buildElements = (start, end, item) => {
    try {
      let elements = [];
      if (item) {
        const user = item;
        for (let i = start; i < end; i++) {
          const temp = this.listItem(user[i]);
          if (temp) {
            elements.push(temp);
          }
        }
      }
      return elements;
    } catch (e) {
      console.log('###### e : ', e);
    } finally {
    }
  };

  listItem = (item) => {
    const { staffChecked } = this.props;
    const { headers } = this.state;
    let isDisabled = false;
    let result = null;
    if (!item) return;
    if (!item.group) {
      isDisabled = true;
    }
    isDisabled = item.policy.some((data) => {
      if (data.type === 'LONGTERM') {
        return true;
      }
    });
    if (item) {
      const division = cm.trTdDivision(item.orgCode);
      let styles = [];
      headers.forEach((headerItem, index) => {
        styles.push({
          flex: `${headerItem.width} 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 0'
        });
      });

      result = (
        <div className="rt-tr -odd" key={item.id} style={{ width: '100%' }}>
          <div className="rt-td" style={styles[0]}>
            <div className="checkbox pure">
              <label>
                <input
                  type="checkbox"
                  id={item.id}
                  name={item.name}
                  disabled={!isDisabled}
                  className={`staff-checkbox ${item.signid}`}
                  value="on"
                  onClick={(e) => staffChecked(e, item, null)}
                />
                <span />
              </label>
            </div>
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.signid}
          </div>
          <div className="rt-td" style={styles[2]}>
            {item.name}
          </div>
          {division.map((divi, i) => {
            return (
              <div key={`divi${i}`} className="rt-td" style={{ flex: '128 0 auto', width: 128 }}>
                <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
              </div>
            );
          })}
          <div className="rt-td" style={styles[3]}>
            {item.group.name}
          </div>
          <div className="rt-td" style={styles[4]}>
            {item.comidnum}
          </div>
          <div className="rt-td" style={styles[5]}>
            {item.grade.text}
          </div>
        </div>
      );
      return result;
    } else {
      return null;
    }
  };

  elementInfiniteLoad = () => {
    const { staffList } = this.props;
    let dom = <Commons.LoadingBar />;
    if (!staffList) {
      dom = null;
    }
    return null;
  };

  scrollHandler = (e) => {
    const { data, staffCheckedData } = this.props;
    staffCheckedData.forEach((data) => {
      const dom = $('#' + data.id);
      if (dom.is(':disabled')) return;
      dom.prop('checked', true);
    });
  };

  tBodyFunc = (state) => {
    const { elements, containerHeight, isInfiniteLoading } = this.state;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          <Infinite
            className="infinite-scroll"
            elementHeight={43}
            containerHeight={containerHeight}
            infiniteLoadBeginEdgeOffset={containerHeight - 50}
            onInfiniteLoad={this.handleInfiniteLoad}
            loadingSpinnerDelegate={this.elementInfiniteLoad()}
            isInfiniteLoading={isInfiniteLoading}
            handleScroll={this.scrollHandler}
          >
            {elements}
          </Infinite>
        </div>
      </div>
    );
  };

  noDataProps = (state) => {
    const { staffList } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (staffList && staffList.data.user) {
      dom = <div className="rt-noData" />;
    }

    return dom;
  };

  render() {
    const { staffChecked } = this.props;
    const { headers } = this.state;

    let header = cm.tableHeaderList(headers, 3, false, 'notMaxWidth');

    const fn = {
      fnChecked: staffChecked,
      move: null
    };
    // let tooltipArray = cm.tooltipHeader(3, null);
    const columns = scroll.header(header, fn);

    return (
      <ReactTable
        className="react-table"
        columns={columns}
        sortable={false}
        resizable={false}
        showPagination={false}
        TbodyComponent={this.tBodyFunc}
        NoDataComponent={this.noDataProps}
      />
    );
  }
}

StaffList.propTypes = propTypes;
StaffList.defaultProps = defaultProps;

StaffList = connect((state) => ({
  staffList: state.commons.staff
}))(StaffList);

export default StaffList;
